import {Component, OnInit} from '@angular/core';
import {StateService} from "../../services/state.service";
import {DetailedOrder, SiteUser, SiteUserService} from "../../services/site-user.service";
import {HttpErrorResponse} from "@angular/common/http";
import {AlertService} from "../../services/alert.service";
import {Router} from "@angular/router";
import {finalize} from "rxjs/operators";

@Component({
    templateUrl: './site-user.component.html',
    styleUrls: ['./site-user.component.css']
})
export class SiteUserComponent implements OnInit {

    readonly user: SiteUser;
    orders: DetailedOrder[] = [];
    loading: boolean = false;
    enablingOrDisabling: boolean = false;

    constructor(private state: StateService,
                private siteUserService: SiteUserService,
                private router: Router,
                private alertService: AlertService) {
        this.user = state.get('currentUser');
    }

    ngOnInit(): void {
        this.loading = true;
        this.siteUserService.getOrders(this.user).pipe(
            finalize(() => {this.loading = false})
        ).subscribe((out) => {
            this.orders = out;
        }, (err: HttpErrorResponse) => {
            this.alertService.error(err.error.message);
        });
    }

    get userRace(): string {
        return this.user.race.join(", ");
    }

    disableUser() {
        this.alertService.confirm("Are you sure you want to disable this user?")
            .subscribe((doIt) => {
                if (doIt) {
                    this.enablingOrDisabling = true;
                    this.siteUserService.disable(this.user).pipe(
                        finalize(() => {this.enablingOrDisabling = false})
                    ).subscribe((out) => {
                        this.alertService.info("User disabled successfully");
                        this.router.navigateByUrl('/site-users').then();
                    }, (err: HttpErrorResponse) => {
                        this.alertService.error(err.error.message);
                    });
                }
            });
    }

    enableUser() {
        this.enablingOrDisabling = true;
        this.siteUserService.enable(this.user).pipe(
            finalize(() => {this.enablingOrDisabling = false})
        ).subscribe((out) => {
            this.alertService.info("User enabled successfully");
            this.router.navigateByUrl('/site-users').then();
        }, (err: HttpErrorResponse) => {
            this.alertService.error(err.error.message);
        })
    }
}
